import { render } from "./ExpertTimedEssayArea.vue?vue&type=template&id=6b084882&scoped=true"
import script from "./ExpertTimedEssayArea.vue?vue&type=script&lang=js"
export * from "./ExpertTimedEssayArea.vue?vue&type=script&lang=js"

import "./ExpertTimedEssayArea.vue?vue&type=style&index=0&id=6b084882&lang=css"
import "@/assets/css/essayWriting.sass?vue&type=style&index=1&id=6b084882&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b084882"]])

export default __exports__